/** @jsxImportSource @emotion/react */
import { FileUploadField } from "../../../components/forms/fields/FileUploadField";
import { useFormContext } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { css } from "@emotion/react";
import { FileUploadWrapper } from "../../../components/FileUploadWrapper";
import { FileUploadFormat } from "../../../components/forms/inputs/FileUploadInput";

type Props = {
  onDrop: (acceptedFiles: File[]) => void;
  file: File | undefined;
  isLoading?: boolean;
};

const uploadHeaderStyle = css`
  display: flex;
  flex-direction: column;
`;

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const ChallengeImageWrapper = ({ onDrop, file, isLoading }: Props) => {
  const {
    setValue,
    formState: { errors: formErrors },
  } = useFormContext();

  return (
    <div css={wrapperStyle}>
      <FileUploadField accept={FileUploadFormat.IMAGE} onDrop={onDrop} />
      {file && (
        <>
          <StyledText
            css={uploadHeaderStyle}
            color={colors.textPrimary}
            className="bodyTextSemibold mb-0"
          >
            Uploads
          </StyledText>
          <FileUploadWrapper
            file={file}
            isLoading={isLoading}
            remove={() => {
              setValue("files", []);
            }}
          />
          <StyledText
            color={colors.textSecondary}
            className="bodyTextRegular mb-0"
          >
            1 of 1 uploads
          </StyledText>
        </>
      )}
      {formErrors.files && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mb-0"
        >
          {`${formErrors.files.message}`}
        </StyledText>
      )}
    </div>
  );
};
